<template>
  <form-group v-bind="$attrs">
    <v-row>
      <v-col cols="12">
        <v-tabs v-model="tabs">
          <v-tab>
            <skeleton
              :height="20"
              :width="50"
            />
          </v-tab>
          <v-tab>
            <skeleton
              :height="20"
              :width="50"
            />
          </v-tab>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <skeleton
                :height="600"
                :width="800"
              />
            </v-tab-item>
            <v-tab-item>
              <skeleton
                :height="600"
                :width="800"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-col>
    </v-row>
  </form-group>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import Skeleton from '@/app/arch/components/global-components/Skeleton.vue';

export default {
  name: 'ContaCardDisplayShimmer',
  components: { FormGroup, Skeleton },
  data: () => ({
    tabs: null,
  }),
};
</script>
